import _classCallCheck from "/Users/phil/Workspace/petroff-billing-master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/phil/Workspace/petroff-billing-master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var CustomerService = /*#__PURE__*/function () {
  function CustomerService(https, config) {
    _classCallCheck(this, CustomerService);
    this.https = https;
    this.config = config;
  }
  _createClass(CustomerService, [{
    key: "getCustomer",
    value: function getCustomer(id, callback) {
      this.https.get('/api/customer/' + id).then(function (response) {
        callback(response);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "customerSearch",
    value: function customerSearch(searchTerm, take, skip, includeDisabled, searchCallback) {
      var searchData = {
        searchTerm: searchTerm,
        company: this.config.deployment,
        take: take,
        skip: skip,
        includeDisabled: includeDisabled
      };
      this.https.post("/api/customers", searchData).then(function (data) {
        searchCallback(data.results);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "updateCustomer",
    value: function updateCustomer(customer, callback) {
      return this.https.post('/api/customers/update', customer).then(function (response) {
        callback(response.data);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "createCustomer",
    value: function createCustomer(customer, callback) {
      var customerData = {
        customer: customer,
        company: this.config.deployment
      };
      this.https.post('/api/customers/create', customerData).then(function (response) {
        if (response.error) {
          callback(response.error);
        } else {
          callback(null, response.results.insertId);
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }]);
  return CustomerService;
}();
export default CustomerService;